<template>
  <el-dialog
    title="Complete Event"
    :visible.sync="isVisible"
    :close-on-click-modal="!isCompletingEvent"
    :close-on-press-escape="!isCompletingEvent"
    :show-close="!isCompletingEvent"
    @closed="$emit('destroy')"
  >
    <el-dialog
      width="30%"
      title="Notice"
      :visible.sync="isPromptingNewEvent"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      append-to-body
    >
      You are required to create a follow-on event

      <template #footer>
        <el-button
          type="primary"
          @click.native="createFollowOnEvent"
        >
          OK
        </el-button>
      </template>
    </el-dialog>

    <EventCompleteForm
      :event="event"
      :note="note"
    />

    <template #footer>
      <el-button
        :disabled="isCompletingEvent"
        @click.native="isVisible = false"
      >
        Cancel
      </el-button>

      <el-button
        type="primary"
        :loading="isCompletingEvent"
        @click.native="completeEvent"
      >
        Complete Event
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import EventCompleteForm from '@/components/Application/Sales/Events/Event/CompleteForm'
import Filter, { IS } from '@/plugins/sdk/Filter'

export default {
  components: {
    EventCompleteForm
  },
  props: {
    event: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isVisible: true,
      isCompletingEvent: false,
      isPromptingNewEvent: false,
      note: new this.$sdk.note()
    }
  },
  methods: {
    async completeEvent () {
      this.isCompletingEvent = true

      const account = this.event.account.clone()

      try {
        const noteClone = this.note.clone()
        noteClone.resource = this.event
        noteClone.resource_uuid = this.event.id

        await noteClone.create()

        this.event.completed_at = noteClone.created_at

        if (this.event.account && this.event.account.modified) {
          // If the account has been modified ensure that it
          // is reset before the update request is sent.
          this.event.account.reset()
        }

        try {
          await this.event.update(builder => {
            builder.include = [ 'account.lead', 'type.next_event_type' ]
          })

          try {
            await account.update(builder => {
              builder.include = [ 'lead' ]
            })
          } catch {
            this.$message.error('Failed to update Account Status')
          }

          let promptNewEvent = this.event.type && this.event.type.next_event_required

          if (promptNewEvent) {
            if (typeof account !== 'undefined' && this.event.account.status !== account.status) {
              try {
                const types = await this
                  .$sdk
                  .account_event_type
                  .list(builder => {
                    builder.filters = [ new Filter('for_account_status', IS, this.event.account.status) ]
                  })

                if (types.length > 0) {
                  this.event.type.next_event_type = undefined
                } else {
                  promptNewEvent = false
                }
              } catch {
                promptNewEvent = false
              }
            } else {
              if (this.event.type.next_event_type instanceof this.$sdk.account_event_type &&
                this.event.type.next_event_type.for_account_status &&
                this.event.type.next_event_type.for_account_status !== account.status) {
                promptNewEvent = false
              }
            }
          }

          this.event.account = account.clone()

          this.$message.success('Successfully updated Event')
          this.$emit('completed-event', this.event)

          if (promptNewEvent) {
            this.isPromptingNewEvent = true
          } else {
            this.isVisible = false
          }
        } catch {
          this.$message.error('Failed to update Event')
        }
      } catch {
        this.$message.error('Failed to add closing note to Event')
      }

      this.isCompletingEvent = false
    },
    createFollowOnEvent () {
      this.isPromptingNewEvent = false

      const newEvent = new this.$sdk.account_event()

      newEvent.account = this.event.account
      newEvent.type = this.event.type.next_event_type

      this.$emit('new-event', newEvent)

      this.isVisible = false
    }
  }
}
</script>
